import * as React from "react";
import {
  Box,
  Stack,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import EventNoteRoundedIcon from "@mui/icons-material/EventNoteRounded";
import MedicalServicesRoundedIcon from "@mui/icons-material/MedicalServicesRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import { Colors } from "../../utils/Colors";

const menuItems = [
  { label: "Dashboard", icon: <DashboardRoundedIcon fontSize="small" />, active: true },
  { label: "Patients", icon: <PeopleAltRoundedIcon fontSize="small" /> },
  { label: "Appointments", icon: <EventNoteRoundedIcon fontSize="small" /> },
  { label: "Prescriptions", icon: <MedicalServicesRoundedIcon fontSize="small" /> },
  { label: "Reports", icon: <DescriptionRoundedIcon fontSize="small" /> },
  { label: "Settings", icon: <SettingsRoundedIcon fontSize="small" /> },
];

export default function DoctorSidebar() {
  return (
    <Box
      sx={{
        width: 270,
        minHeight: "100vh",
        bgcolor: Colors.bg.paper,
        borderRight: `1px solid ${Colors.border.light}`,
        p: 2,
      }}
    >
      <Box
        sx={{
          px: 1,
          py: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 800,
            color: Colors.brand.primary,
            letterSpacing: 0.3,
          }}
        >
          Fludee Doctor
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: Colors.text.muted,
            mt: 0.5,
          }}
        >
          Clinical dashboard panel
        </Typography>
      </Box>

      <Box
        sx={{
          height: 6,
          borderRadius: 999,
          bgcolor: Colors.brand.accentBar,
          mb: 2,
        }}
      />

      <List sx={{ p: 0 }}>
        {menuItems.map((item) => (
          <ListItemButton
            key={item.label}
            sx={{
              mb: 0.8,
              borderRadius: 3,
              bgcolor: item.active ? Colors.brand.primary : "transparent",
              color: item.active ? "#fff" : Colors.text.body,
              "&:hover": {
                bgcolor: item.active ? Colors.brand.primaryDark : Colors.bg.hover,
              },
            }}
          >
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: item.active ? "#fff" : Colors.text.icon,
                }}
              >
                {item.icon}
              </Box>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: item.active ? 700 : 600,
                }}
              />
            </Stack>
          </ListItemButton>
        ))}
      </List>

      <Divider sx={{ my: 2, borderColor: Colors.border.light }} />

      <Box
        sx={{
          p: 2,
          borderRadius: 4,
          bgcolor: Colors.bg.app,
          border: `1px solid ${Colors.border.light}`,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 700, color: Colors.text.title }}
        >
          Doctor Status
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: Colors.text.muted, mt: 0.5 }}
        >
          You are online and receiving patient updates.
        </Typography>
      </Box>
    </Box>
  );
}